export default __webpack_public_path__ + "static/media/course.c8cbd5db.mp4";